module.exports = __webpack_public_path__ + "static/media/dsr_logo.aae90c7a.png";